export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=409842feffec06540f089e27ccbb2e89bbcd08b493&name=revalidateCommunity!'